import { logout } from "../redux/actions/user.action";
import { push } from "connected-react-router";


export default function AuthGuard(dispatch:any) {
    if(!window.localStorage.getItem("token") || window.localStorage.getItem("token") == "" || !window.localStorage.getItem("user")) {
        dispatch(push('/'));
    }
}